import { HelperText02 } from 'module/ui/components/styles';
import { Tooltip } from 'antd';
import moment from 'moment';
import styled from 'styled-components';

const MetadataText = styled.div`
  ${HelperText02};
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;

const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-02);
`;

interface MetadataTooltipProps {
  updatedAt?: string;
  createdAt?: string;
}

export const MetadataTooltip = ({
  updatedAt,
  createdAt,
}: MetadataTooltipProps) => {
  if (!updatedAt && !createdAt) {
    return null;
  }

  return (
    <Tooltip
      title={
        <TooltipContent>
          {updatedAt && (
            <div>
              Edited {moment(updatedAt).format('MMM DD, YYYY [at] h:mm A')}
            </div>
          )}
          {createdAt && (
            <div>
              Created {moment(createdAt).format('MMM DD, YYYY [at] h:mm A')}
            </div>
          )}
        </TooltipContent>
      }
    >
      <MetadataText>
        {updatedAt && <>Edited {moment(updatedAt).format('MMM DD')}</>}
      </MetadataText>
    </Tooltip>
  );
};
